import { Pipe, PipeTransform } from '@angular/core';
import { Sector} from '@apply4u/models/BrowseA4UContents/sector';
import { IsNotNull,IsNotNullOrEmpty,IsNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { CvSearch_RouteUrl, Jobs_RouteUrl} from '@apply4u/shared/constant/navigation/navigation';
import { Jobs, CVS} from '@apply4u/shared/constant/navigation/query-param';

@Pipe({
  name: 'SearchByIndustryPipe',
  standalone:true
})
export class SearchByIndustryPipe implements PipeTransform {
  transform(value: Sector, isjob: boolean): string {
    let createdUrl = "";

    if (IsNotNull(value) && IsNotNullOrEmpty(value.SectorSeoName) && isjob) {

      createdUrl = Jobs_RouteUrl + "/" + value.SectorSeoName.replace(/\s+/g, '-') + Jobs;
      createdUrl = createdUrl.toLowerCase();
    } else if (IsNotNull(value) && IsNotNullOrEmpty(value.SectorSeoName) && !isjob) {

      createdUrl = CvSearch_RouteUrl + "/" + value.SectorSeoName.replace(/\s+/g, '-') + CVS;
      createdUrl = createdUrl.toLowerCase();
    } else if (IsNotNull(value) && IsNullOrEmpty(value.SectorSeoName) && isjob){

      createdUrl = Jobs_RouteUrl + "/" + value + Jobs;
      createdUrl = createdUrl.toLowerCase();
    } else if (IsNotNull(value) && IsNullOrEmpty(value.SectorSeoName) && !isjob) {

      createdUrl = CvSearch_RouteUrl + "/" + value + CVS;
      createdUrl = createdUrl.toLowerCase();
    }
    return createdUrl;
  }
}
